import { fromPairs, map, size } from "lodash";
import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import { arrayWithNEmptyItems } from "../../../../utils/array";
import {
  formatPhoneWithDdd,
  formatMonetary,
  formatPercentage,
  timeStampToDate,
  formatCNPJ,
  formatUpperCase,
} from "../../../../utils/formats";
import { Label, Separator, Text } from "../styles";

const InformacoesProfissionaisSection = (props) => {
  const {
    proposalCompleteRegistrationLoading,
    participacoesOutrasEmpresasLoading,
    trabalhoNomeEmpresa,
    trabalhoCnpjEmpresa,
    trabalhoEnderecoEmpresa,
    trabalhoCepEmpresa,
    trabalhoNumeroEmpresa,
    trabalhoComplementoEmpresa,
    trabalhoBairroEmpresa,
    trabalhoCidadeEmpresa,
    trabalhoUfEmpresa,
    trabalhoDddTelefoneEmpresa,
    trabalhoTelefoneEmpresa,
    rendaBruta,
    dataAdmissao,
    descricaoProfissao,
    descricaoCargo,
    participacoesOutrasEmpresas,
  } = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item md={8}>
          <Input
            label="Nome da empresa"
            value={formatUpperCase(trabalhoNomeEmpresa)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="CNPJ"
            value={trabalhoCnpjEmpresa}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={8}>
          <Input
            label="Endereço"
            value={formatUpperCase(trabalhoEnderecoEmpresa)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="CEP"
            value={trabalhoCepEmpresa}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Número"
            value={trabalhoNumeroEmpresa}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Complemento"
            value={formatUpperCase(trabalhoComplementoEmpresa)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Bairro"
            value={formatUpperCase(trabalhoBairroEmpresa)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Cidade"
            value={formatUpperCase(trabalhoCidadeEmpresa)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="UF"
            value={trabalhoUfEmpresa}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="País"
            value=""
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Telefone"
            value={formatPhoneWithDdd(
              trabalhoDddTelefoneEmpresa,
              trabalhoTelefoneEmpresa
            )}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Renda"
            value={formatMonetary(rendaBruta)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Data de admissão"
            value={timeStampToDate(dataAdmissao)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Profissão"
            value={formatUpperCase(descricaoProfissao)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
        <Grid item md={4}>
          <Input
            label="Cargo"
            value={formatUpperCase(descricaoCargo)}
            loading={proposalCompleteRegistrationLoading}
          />
        </Grid>
      </Grid>

      <Separator />

      <Grid container spacing={3}>
        {size(participacoesOutrasEmpresas) == 0 &&
          !participacoesOutrasEmpresasLoading && (
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Label>Empresa em que participa</Label>
                </Grid>
              </Grid>
              <Text>SEM DADOS.</Text>
            </Grid>
          )}
        {map(
          participacoesOutrasEmpresasLoading
            ? arrayWithNEmptyItems(1)
            : participacoesOutrasEmpresas,
          (it, index) => {
            return (
              <React.Fragment key={index + it.cpfCnpj}>
                <Grid item xs={12}>
                  <Label>Empresa em que participa {index + 1}</Label>
                </Grid>
                <Grid item md={4}>
                  <Input
                    label="CNPJ"
                    value={formatCNPJ(it.cpfCnpj)}
                    loading={participacoesOutrasEmpresasLoading}
                  />
                </Grid>
                <Grid item md={4}>
                  <Input
                    label="Razão social"
                    value={formatUpperCase(it.nomeEmpresa)}
                    loading={participacoesOutrasEmpresasLoading}
                  />
                </Grid>
                <Grid item md={4}>
                  <Input
                    label="Participação"
                    value={formatPercentage(it.percentualParticipacao)}
                    loading={participacoesOutrasEmpresasLoading}
                  />
                </Grid>
                <Grid item md={4}>
                  <Input
                    label="Cidade"
                    value={formatUpperCase(it.nomeCidade)}
                    loading={participacoesOutrasEmpresasLoading}
                  />
                </Grid>
                <Grid item md={4}>
                  <Input
                    label="UF"
                    value={formatUpperCase(it.siglaEstado)}
                    loading={participacoesOutrasEmpresasLoading}
                  />
                </Grid>
              </React.Fragment>
            );
          }
        )}
      </Grid>
    </>
  );
};

export default InformacoesProfissionaisSection;
